module.exports = __webpack_public_path__ + "static/media/vip_align.9bad5082.svg";